/**
 * CargaPesquisaSatisfacao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaPesquisaSatisfacaoCollection} from '@/model/collection/CargaPesquisaSatisfacaoCollection'

/* TODO: review generated class */
export class CargaPesquisaSatisfacao extends Resource {
  @ResponseSerialize(Carga)
  carga: Carga | null = null

  notaPergunta1: number | null = null
  dataCriacao: string | null = null

  notaPergunta2: number | null = null
  urlFotoSilenciosa: string | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaPesquisaSatisfacao
   */
  async getCargaPesquisaSatisfacao(id: number) {
    return await Request.get(`/admin/carga-pesquisa-satisfacao/${id}`)
      .name('getCargaPesquisaSatisfacao')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaPesquisaSatisfacao
   */
  static async listCargaPesquisaSatisfacao(params: any) {
    return await Request.get(`/admin/carga-pesquisa-satisfacao`, {params})
      .name('listCargaPesquisaSatisfacao')
      .as(CargaPesquisaSatisfacaoCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaPesquisaSatisfacao. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaPesquisaSatisfacao() {
    return await Request.post(`/admin/carga-pesquisa-satisfacao`, this)
      .name('persistCargaPesquisaSatisfacao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaPesquisaSatisfacao to use it in a CSV file
   */
  static async listCsvCargaPesquisaSatisfacao(params: any) {
    return await Request.get(`/admin/carga-pesquisa-satisfacao/csv`, {params})
      .name('listCsvCargaPesquisaSatisfacao')
      .as(CargaPesquisaSatisfacaoCollection)
      .getData()
  }
}
